
const initialState = {
  AllConversations: [],
  CampaignConversations: [],
  CurrentConversation: null,
  ConversationMessages: [],
  ConversationStats: null,
  AIConfig: null,
}

const conversationReducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case 'SET_ALL_CONVERSATIONS': {
      return {
        ...state,
        AllConversations: payload,
      }
    }
    case 'SET_CAMPAIGN_CONVERSATIONS': {
      return {
        ...state,
        CampaignConversations: payload,
      }
    }
    case 'SET_CURRENT_CONVERSATION': {
      return {
        ...state,
        CurrentConversation: payload,
      }
    }
    case 'SET_CONVERSATION_MESSAGES': {
      return {
        ...state,
        ConversationMessages: payload,
      }
    }
    case 'SET_CONVERSATION_STATS': {
      return {
        ...state,
        ConversationStats: payload,
      }
    }
    case 'SET_AI_CONFIG': {
      return {
        ...state,
        AIConfig: payload,
      }
    }
    default:
      return state
  }
}

export default conversationReducer
